
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  SET_ACTIVITIES: (state, payload) => state.activities = payload,

}